<div class="text-center" style="margin-top: 20px; margin-bottom: 20px">
  <a (click)="openSubFlowsheet()" class="btn btn-primary" style="margin-bottom: 15px">
    <i class="fa fa-window-maximize"></i> Use Subflowsheet
  </a>
  <hr />
</div>
